import { Box, Typography } from '@mui/material';
import React, { useEffect, useRef } from 'react'
import InfoIcon from "@mui/icons-material/Info";
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider';

function ValidateAPIResponse(props: {
	currentSelectedResponse: string | null;
	apiResponses: any;
}) {
	const { translate } = usePortalTranslation();
    const CUR_COMPONENT = "Validate API";
	const { currentSelectedResponse, apiResponses } = props
	const jsonCodeElementRef = useRef<HTMLInputElement>(null);

	useEffect(() => {
		if (currentSelectedResponse) {
			jsonCodeElementRef.current?.scrollIntoView({ behavior: "smooth" });
		}
	}, [currentSelectedResponse]);

	return (
		<>
			{
				currentSelectedResponse && apiResponses && apiResponses[currentSelectedResponse]?.type ===
					"success" ? (
					<pre
						className="jsonResponse"
						ref={jsonCodeElementRef}
					>
						{JSON.stringify(
							apiResponses[currentSelectedResponse]
								.data,
							null,
							2
						)}
					</pre>
				) : currentSelectedResponse &&
					apiResponses &&
					apiResponses[currentSelectedResponse]?.type ===
					"error" ? (
					<Box className="selectResponsebox">
						<InfoIcon
							className="infoIconError"
							color="error"
						/>
						<Typography>
							{currentSelectedResponse &&
								apiResponses &&
								apiResponses[
									currentSelectedResponse
								].error}
						</Typography>
					</Box>
				) : (
					<Box className="selectResponsebox">
						<InfoIcon className="infoIconMessage" />
						<Typography>
						{translate(TranslationEnum.validate_api,"Select Response to view")}
						</Typography>
					</Box>
				)}
		</>
	)
}

export default ValidateAPIResponse